export default __webpack_public_path__ + "static/media/grapes-home.9c3c1f46.png";